export default __webpack_public_path__ + "static/media/WoodCountyLogo.d2b657fc.png";